import { FC } from "react";
import Image from "next/image";
import { TechnologyIconType } from "../../../@types/types-body";

export const TechnologyIcon: FC<TechnologyIconType> = ({ image, title }) => {
  return (
      <div className={"flex flex-col m-8"}>
          <div className="w-28 h-28 bg-white rounded-full shadow-2xl border-2 p-4 relative justify-center align-middle flex">
              <Image src={image} alt={""} className="mx-auto p-5 w-24 h-24" fill={true}/>
          </div>
          <p className={"mx-auto text-xl lg:text-2xl italic"}>{title}</p>
      </div>
  );
};
